import { DeleteOutline } from '@mui/icons-material';
import { Alert } from '@mui/material';
import ConsultantConfirmDialog from './ConsultantConfirmDialog';

// The API has no endpoint for deleting a consultant yet, so this dialog explains that
// and points to deactivation instead of pretending the delete succeeded.
// When an endpoint exists, call it in an onConfirm handler (see DeactiveConsultant.jsx).
export default function DeleteConsultant({ open, onClose, consultant }) {
  return (
    <ConsultantConfirmDialog
      open={open}
      onClose={onClose}
      consultant={consultant}
      color="#d32f2f"
      icon={<DeleteOutline />}
      title="Delete consultant?"
      description="Deleting permanently removes the consultant's account."
      consequences={[
        'They will no longer be able to sign in.',
        'This cannot be undone.',
      ]}
      notice={
        <Alert severity="info" sx={{ borderRadius: '12px' }}>
          Deleting consultants isn't available yet. To remove their access now, use{' '}
          <strong>Deactivate</strong> instead. It can be reversed later.
        </Alert>
      }
      confirmLabel="Delete"
      onConfirm={() => {}}
      confirmDisabled
    />
  );
}
